/**
 * @license
 * Copyright 2022 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
export const COMPONENT_NAME_PREFIX = 'forge-';
export const KEYSTROKE_DEBOUNCE_THRESHOLD = 500;
export const ICON_CLASS_NAME = 'tyler-icons';
export const CDN_BASE_URL = 'https://cdn.forge.tylertech.com/';
